module.exports = __webpack_public_path__ + "img/10_89.3f7e129d.png";